import { render, staticRenderFns } from "./SingleDepartment.vue?vue&type=template&id=76047717&"
import script from "./SingleDepartment.vue?vue&type=script&lang=js&"
export * from "./SingleDepartment.vue?vue&type=script&lang=js&"
import style0 from "./SingleDepartment.vue?vue&type=style&index=0&id=76047717&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports